/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { NavigationSection } from '@squiz/sds';
import { NAV_SECTION_DATA_IDS } from 'dxpConsoleCore-mf/Constants';
import {
  DXP_MENU_AGENCY_CORE_SCREENS,
  DXP_MENU_AGENCY_SCREENS,
  DXP_MENU_ORGANISATION_ADMIN_SCREENS,
  DXP_MENU_USER_MANAGEMENT_SCREENS,
} from './NavItems.constants';
import { ADMIN_STRINGS } from './Strings.constants';

/**
 * The main navigation menu section for all items that make up DXP Console Organization screens.
 */
export const DXP_MENU_ORGANISATION_ADMIN_SECTION: NavigationSection = {
  items: DXP_MENU_ORGANISATION_ADMIN_SCREENS,
  key: `menu-section-org-admin`,
  label: ADMIN_STRINGS.organisation,
  showLabel: false,
};

/**
 * The main navigation menu section for all items that make up DXP Console Agency screens.
 */
export const DXP_MENU_AGENCY_ADMIN_SECTION: NavigationSection = {
  dataId: NAV_SECTION_DATA_IDS.agency,
  items: DXP_MENU_AGENCY_SCREENS,
  key: `menu-section-agency`,
  label: ADMIN_STRINGS.dashboard,
  showLabel: false,
};

/**
 * The main navigation menu section for all core items that make up DXP Console Agency screens.
 */
export const DXP_MENU_AGENCY_CORE_SECTION: NavigationSection = {
  dataId: NAV_SECTION_DATA_IDS.agency,
  items: DXP_MENU_AGENCY_CORE_SCREENS,
  key: `menu-section-dxp-agency-core`,
  label: `Agency Core`,
  showLabel: false,
};

/**
 * The main navigation menu section for User Management screens.
 */
export const DXP_MENU_USER_MANAGEMENT_SECTION: NavigationSection = {
  items: DXP_MENU_USER_MANAGEMENT_SCREENS,
  key: `menu-section-user-management`,
  label: ADMIN_STRINGS.access,
  showLabel: true,
};
